import moment from 'moment'
import { Locations } from 'tripPlanner/pages/trip/GenerateTripPage'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'

export function calculateTripDays(startDate: Date, endDate: Date): number {
  return moment(endDate).diff(moment(startDate), 'days') + 1
}

export function distributeDaysEvenly(totalDays: number, locationCount: number): Array<number> {
  if (locationCount === 0) {
    return []
  }

  const baseDays = Math.floor(totalDays / locationCount)
  const remainder = totalDays % locationCount

  const distribution = new Array(locationCount).fill(baseDays)

  if (remainder > 0) {
    distribution[locationCount - 1] += remainder
  }

  return distribution
}

export function updateLocationsWithDurations(
  locations: Array<Locations>,
  startDate: Date,
  durations: Array<number>,
): Array<Locations> {
  const currentDate = moment(startDate)

  const updatedLocations = locations.map((location, index) => {
    const duration = durations[index] || 1
    const locationStartDate = currentDate.format(ISO_DATE_FORMAT)
    const locationEndDate = currentDate.add(duration - 1, 'days').format(ISO_DATE_FORMAT)

    currentDate.add(1, 'day')

    return {
      ...location,
      startDate: locationStartDate,
      endDate: locationEndDate,
      duration,
    }
  })

  return updatedLocations
}

export function calculateNewTripEndDate(startDate: Date, durations: Array<number>): Date {
  const totalDays = durations.reduce((sum, duration) => sum + duration, 0)
  return moment(startDate).add(totalDays - 1, 'days').toDate()
}

export function updateLocationDuration(
  locations: Array<Locations>,
  locationIndex: number,
  newDuration: number,
  tripStartDate: Date,
): { updatedLocations: Array<Locations>, newTripEndDate: Date } {
  if (newDuration < 1) return { updatedLocations: locations, newTripEndDate: tripStartDate }

  const updatedLocations = [...locations]
  updatedLocations[locationIndex] = {
    ...updatedLocations[locationIndex],
    duration: newDuration,
  }

  const durations = updatedLocations.map(loc => loc.duration || 1)
  const finalLocations = updateLocationsWithDurations(updatedLocations, tripStartDate, durations)
  const newTripEndDate = calculateNewTripEndDate(tripStartDate, durations)

  return { updatedLocations: finalLocations, newTripEndDate }
}
